// src/utils/config.js
let baseUrl = "https://quirckart.in/"; // Production server URL


export const setBaseUrl = (url) => {
    baseUrl = url;
};

export const getBaseUrl = () => {
    return baseUrl;
};

